const combineClassNames = (...classNames: (string | undefined)[]) => {
    return classNames.filter((className) => className && className.length > 0).join(" ");
};
export default combineClassNames;
